import PlaceholderScreen from '../../components/PlaceholderScreen/PlaceholderScreen'

export default function GroupsScreen() {
  return <PlaceholderScreen title="Groups" />
}